/* Seventy Seven Swim — theme interactions */
/* eslint-env browser */
/* global Shopify */
(function () {
  var scrim, menu, cart, searchPanel;

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function closeOverlays() {
    [menu, cart].forEach(function (d) {
      if (d && d.classList.contains('is-open')) {
        d.classList.add('is-closing');
        d.classList.remove('is-entered');
        var done = function () {
          d.removeEventListener('transitionend', done);
          /* If it was reopened in the meantime, openOverlay cleared is-closing — leave it open. */
          if (!d.classList.contains('is-closing')) return;
          d.classList.remove('is-open', 'is-closing');
        };
        d.addEventListener('transitionend', done);
        setTimeout(done, 320); /* fallback; done() is idempotent */
      }
    });
    if (scrim) scrim.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  function openOverlay(el) {
    if (!el) return;
    el.classList.remove('is-closing');
    el.classList.add('is-open');
    /* Two frames later: trigger the staggered content reveal. */
    requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.add('is-entered'); }); });
    if (scrim) scrim.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  /* True when any drawer/search overlay is open (used to keep the header pinned). */
  function overlaysOpen() {
    return document.body.style.overflow === 'hidden'
      || (searchPanel && searchPanel.classList.contains('is-open'))
      || (menu && menu.classList.contains('is-open'))
      || (cart && cart.classList.contains('is-open'));
  }

  function bindOverlayTriggers(ctx) {
    qsa('[data-open-cart]', ctx).forEach(function (b) { if (b.__overlayBound) return; b.__overlayBound = true; b.addEventListener('click', function (e) { e.preventDefault(); openOverlay(cart); }); });
    qsa('[data-open-menu]', ctx).forEach(function (b) { if (b.__overlayBound) return; b.__overlayBound = true; b.addEventListener('click', function (e) { e.preventDefault(); openOverlay(menu); }); });
    qsa('[data-close]', ctx).forEach(function (b) { if (b.__overlayBound) return; b.__overlayBound = true; b.addEventListener('click', closeOverlays); });
  }

  var overlayKeydownBound = false;
  /* Re-resolve drawer/scrim refs (they may be replaced when Header reloads in Customize). */
  function resolveOverlays() {
    scrim = qs('#ss-scrim') || scrim;
    menu = qs('#ss-menu') || menu;
    cart = qs('#ss-cart') || cart;
    if (scrim && !scrim.__scrimBound) { scrim.__scrimBound = true; scrim.addEventListener('click', closeOverlays); }
  }

  function initOverlays() {
    resolveOverlays();
    if (!overlayKeydownBound) {
      overlayKeydownBound = true;
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeOverlays(); });
    }
    bindOverlayTriggers(document);
  }

  /* ---- Search panel ---- */
  function bindSearchTriggers(ctx) {
    searchPanel = qs('#ss-search') || searchPanel;
    if (!searchPanel) return;
    qsa('[data-open-search]', ctx).forEach(function (b) {
      if (b.__searchBound) return;
      b.__searchBound = true;
      b.addEventListener('click', function (e) {
        e.preventDefault();
        searchPanel.classList.add('is-open');
        var input = qs('input', searchPanel);
        if (input) setTimeout(function () { input.focus(); }, 200);
      });
    });
    qsa('[data-close-search]', searchPanel).forEach(function (b) {
      if (b.__searchBound) return;
      b.__searchBound = true;
      b.addEventListener('click', function () { searchPanel.classList.remove('is-open'); });
    });
  }
  function initSearch() { bindSearchTriggers(document); }

  /* ---- Accordions ---- */
  function initAccordions(ctx) {
    qsa('.acc__head', ctx).forEach(function (head) {
      if (head.__accordionBound) return;
      head.__accordionBound = true;
      head.addEventListener('click', function () {
        var item = head.closest('.acc__item');
        item.classList.toggle('is-open');
      });
    });
  }

  /* ---- Cart (AJAX + Section Rendering API) ---- */
  var cartDrawerSectionId = 'cart-drawer';

  function refreshCartDrawer() {
    return fetch('/?section_id=' + cartDrawerSectionId)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newDrawer = doc.querySelector('#ss-cart');
        if (newDrawer && cart) {
          cart.innerHTML = newDrawer.innerHTML;
          bindCartDrawerEvents();
          bindOverlayTriggers(cart);
        }
      });
  }

  function updateCartCount(count) {
    qsa('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function bindCartDrawerEvents(ctx) {
    var scope = ctx || cart;
    qsa('[data-cart-remove]', scope).forEach(function (btn) {
      if (btn.__cartRemoveBound) return;
      btn.__cartRemoveBound = true;
      btn.addEventListener('click', function () {
        var line = btn.dataset.cartRemove;
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: line, quantity: 0 })
        }).then(function (res) { return res.json(); })
          .then(function (state) { updateCartCount(state.item_count); return refreshCartDrawer(); });
      });
    });
    qsa('[data-cart-qty]', scope).forEach(function (input) {
      if (input.__cartQtyBound) return;
      input.__cartQtyBound = true;
      input.addEventListener('change', function () {
        var line = input.dataset.cartQty;
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: line, quantity: parseInt(input.value, 10) || 0 })
        }).then(function (res) { return res.json(); })
          .then(function (state) { updateCartCount(state.item_count); return refreshCartDrawer(); });
      });
    });
  }

  function addToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    }).then(function (res) {
      if (!res.ok) return res.json().then(function (err) { throw err; });
      return res.json();
    }).then(function () {
      return fetch('/cart.js').then(function (r) { return r.json(); });
    }).then(function (state) {
      updateCartCount(state.item_count);
      return refreshCartDrawer();
    }).then(function () {
      openOverlay(cart);
    });
  }

  function initAddToCartForms(ctx) {
    qsa('[data-atc-form]', ctx).forEach(function (form) {
      if (form.__atcBound) return;
      form.__atcBound = true;
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        var variantId = form.querySelector('[name="id"]').value;
        if (!variantId) return;
        if (btn) btn.setAttribute('disabled', 'disabled');
        addToCart(variantId, 1).catch(function (err) {
          console.error(err);
        }).finally(function () {
          if (btn) btn.removeAttribute('disabled');
        });
      });
    });
  }

  /* ---- Product page: variant picker + gallery + size modal ---- */
  function initProductPage(ctx) {
    var root = qs('[data-product-root]', ctx || document);
    if (!root) return;
    if (root.__productBound) return; /* don't re-bind variant option handlers */

    var dataEl = qs('[data-product-json]', root);
    if (!dataEl) return;
    var product;
    try {
      product = JSON.parse(dataEl.textContent);
    } catch (err) {
      console.error('[Theme] product JSON parse failed:', err);
      return; /* exit only the variant picker; gallery/motion/cart keep working */
    }
    /* Mark bound only after a successful parse, so a transient bad JSON can retry later. */
    root.__productBound = true;
    if (Array.isArray(product)) { product = { variants: product }; }
    if (!product || typeof product !== 'object') { product = { variants: [] }; }
    if (!Array.isArray(product.variants)) { product.variants = []; }

    var colorInputs = qsa('[data-option-color]', root);
    var sizeInputs = qsa('[data-option-size]', root);
    var priceEls = qsa('[data-product-price], [data-product-price-sticky]'); /* sticky bar sits outside the product root */
    var availEl = qs('[data-product-avail]', root);
    var variantIdFields = qsa('[data-variant-id-field]', root);
    var ctaButtons = qsa('[data-atc-button]', root);

    function selectedOptions() {
      var color = colorInputs.filter(function (i) { return i.classList.contains('is-active'); })[0];
      var size = sizeInputs.filter(function (i) { return i.classList.contains('is-active'); })[0];
      return { color: color ? color.dataset.optionColor : null, size: size ? size.dataset.optionSize : null };
    }

    function findVariant(opts) {
      return product.variants.filter(function (v) {
        var ok = true;
        if (opts.color) ok = ok && v.options.indexOf(opts.color) !== -1;
        if (opts.size) ok = ok && v.options.indexOf(opts.size) !== -1;
        return ok;
      })[0];
    }

    function formatMoney(cents) {
      var value = (Number(cents) || 0) / 100;
      var fraction = value % 1 === 0 ? 0 : 2;
      try {
        return new Intl.NumberFormat('en-GB', {
          style: 'currency',
          currency: 'GBP',
          minimumFractionDigits: fraction,
          maximumFractionDigits: fraction
        }).format(value);
      } catch (err) {
        return '£' + value.toFixed(fraction);
      }
    }

    function refreshAvailableSizes() {
      var opts = selectedOptions();
      sizeInputs.forEach(function (btn) {
        var testOpts = { color: opts.color, size: btn.dataset.optionSize };
        var v = findVariant(testOpts);
        btn.disabled = !v || !v.available;
      });
    }

    function updateForSelection() {
      var opts = selectedOptions();
      var variant = findVariant(opts);
      if (!variant) return;
      priceEls.forEach(function (el) { el.textContent = formatMoney(variant.price); });
      variantIdFields.forEach(function (f) { f.value = variant.id; });
      ctaButtons.forEach(function (b) {
        b.disabled = !variant.available;
        var label = b.dataset.atcLabel || 'Add to bag';
        b.textContent = variant.available ? (label + ' — ' + formatMoney(variant.price)) : 'Sold out';
      });
      if (availEl) {
        if (variant.available) {
          availEl.textContent = 'In stock';
          availEl.classList.remove('is-out');
        } else {
          availEl.textContent = 'Sold out';
          availEl.classList.add('is-out');
        }
      }
      refreshAvailableSizes();
    }

    colorInputs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        colorInputs.forEach(function (x) { x.classList.remove('is-active'); });
        btn.classList.add('is-active');
        var nameEl = qs('[data-color-name]', root);
        if (nameEl) nameEl.textContent = btn.dataset.optionColor;
        updateForSelection();
      });
    });
    sizeInputs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        sizeInputs.forEach(function (x) { x.classList.remove('is-active'); });
        btn.classList.add('is-active');
        var nameEl = qs('[data-size-name]', root);
        if (nameEl) nameEl.textContent = btn.dataset.optionSize;
        updateForSelection();
      });
    });

    refreshAvailableSizes();

    /* Gallery thumb switching is bound separately in initProductGallery()
       so it works even if the variant-picker setup above ever errors. */

    /* Size guide modal */
    var sm = qs('#sizeModal');
    if (sm) {
      qsa('[data-open-size]').forEach(function (b) { b.addEventListener('click', function () { sm.classList.add('is-open'); document.body.style.overflow = 'hidden'; }); });
      qsa('[data-close-size]').forEach(function (b) { b.addEventListener('click', function () { sm.classList.remove('is-open'); document.body.style.overflow = ''; }); });
    }
  }

  /* ---- Product page: gallery thumbnail -> main image ---- */
  function initProductGallery(ctx) {
    var gal = qs('.gal', ctx || document);
    if (!gal) return;
    if (gal.__galleryBound) return; /* never bind a second click handler */
    gal.__galleryBound = true;
    var main = qs('#galMain', gal) || qs('#galMain');

    function activate(thumb) {
      if (!thumb || !main) return;
      qsa('.gal__thumb', gal).forEach(function (x) { x.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      var src = thumb.dataset.src || (thumb.querySelector('img') && thumb.querySelector('img').src);
      if (src) main.src = src;
      var thumbImg = thumb.querySelector('img');
      if (thumbImg && thumbImg.alt) main.alt = thumbImg.alt; /* preserve alt text */
      main.classList.toggle('lifestyle', thumb.dataset.cover === '1');
    }

    /* Event delegation: one listener handles all thumbs, incl. any re-rendered ones. */
    gal.addEventListener('click', function (e) {
      var thumb = e.target.closest ? e.target.closest('.gal__thumb') : null;
      if (thumb && gal.contains(thumb)) {
        e.preventDefault();
        activate(thumb);
      }
    });
  }

  /* ---- Scroll motion: reveal, stagger, parallax (single init; IO + rAF) ---- */
  var reduceMotionMQ = window.matchMedia('(prefers-reduced-motion: reduce)');
  var supportsIO = 'IntersectionObserver' in window;
  var revealIO = null;
  var parallaxEls = [];
  var parallaxContentEls = [];
  var parallaxOverlayEls = [];
  var parallaxBound = false;
  var parallaxTicking = false;

  function motionOff() { return reduceMotionMQ.matches || !supportsIO; }

  function revealOne(el) {
    el.classList.remove('reveal-init');
    el.classList.add('reveal-in');
    /* Clean up animation-only inline styles once the reveal finishes so nothing
       (e.g. a stagger delay) lingers and affects later hover transitions. */
    var done = function () {
      el.style.transitionDelay = '';
      el.removeEventListener('transitionend', done);
    };
    el.addEventListener('transitionend', done);
    setTimeout(done, 1600); /* fallback if transitionend never fires */
  }

  /* Stagger children inherit the container's reveal variant (default/text/media). */
  function prepStaggerChildren(container) {
    var type = container.getAttribute('data-reveal-children') || 'default';
    qsa(':scope > *', container).forEach(function (k) {
      if (!k.hasAttribute('data-reveal')) k.setAttribute('data-reveal', type);
      k.classList.add('reveal-init');
    });
  }

  function revealStagger(container) {
    var kids = qsa(':scope > *', container);
    var step = window.innerWidth < 760 ? 60 : 85;
    kids.forEach(function (el, i) {
      el.style.transitionDelay = (Math.min(i, 6) * step) + 'ms'; /* cap stagger */
      revealOne(el);
    });
  }

  function getRevealIO() {
    if (revealIO) return revealIO;
    revealIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        revealIO.unobserve(el);
        if (el.hasAttribute('data-reveal-stagger')) revealStagger(el);
        else revealOne(el);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.06 });
    return revealIO;
  }

  function inViewport(el) {
    var r = el.getBoundingClientRect();
    return r.top < window.innerHeight && r.bottom > 0;
  }

  /* Element already on screen at init: set hidden state, then run one controlled
     entrance on the next frame. Double rAF lets the browser paint the hidden state
     first so the transition actually runs (and there is no flash of hidden content). */
  function revealVisibleElement(el) {
    if (el.hasAttribute('data-reveal-stagger')) {
      prepStaggerChildren(el);
      requestAnimationFrame(function () { requestAnimationFrame(function () { revealStagger(el); }); });
    } else {
      el.classList.add('reveal-init');
      requestAnimationFrame(function () { requestAnimationFrame(function () { revealOne(el); }); });
    }
  }

  function setupReveals(scope) {
    var io = getRevealIO();
    qsa('[data-reveal], [data-reveal-stagger]', scope).forEach(function (el) {
      if (el.__motionBound) return;
      el.__motionBound = true;
      /* Already visible: animate it once. Below the fold: prepare + observe. */
      if (inViewport(el)) { revealVisibleElement(el); return; }
      if (el.hasAttribute('data-reveal-stagger')) {
        prepStaggerChildren(el);
      } else {
        el.classList.add('reveal-init');
      }
      io.observe(el);
    });
  }

  function parallaxActive() { return !reduceMotionMQ.matches && window.innerWidth >= 760; }

  function collectParallax() {
    parallaxEls = qsa('[data-parallax]').map(function (w) {
      return { wrap: w, img: w.querySelector('img') };
    }).filter(function (o) { return o.img; });
    parallaxContentEls = qsa('[data-parallax-content]');
    parallaxOverlayEls = qsa('[data-parallax-overlay]');
  }

  /* progress of an element's centre relative to the viewport centre, clamped to [-1, 1] */
  function parallaxProgress(rect, vh) {
    var p = ((rect.top + rect.height / 2) - vh / 2) / (vh / 2 + rect.height / 2);
    if (p > 1) return 1; if (p < -1) return -1; return p;
  }

  function updateParallax() {
    parallaxTicking = false;
    if (!parallaxActive()) return;
    var vh = window.innerHeight, MAX = 40, SCALE = 1.10, i, r, p;
    for (i = 0; i < parallaxEls.length; i++) {
      var o = parallaxEls[i];
      r = o.wrap.getBoundingClientRect();
      if (r.bottom < -60 || r.top > vh + 60) continue; /* skip offscreen */
      p = parallaxProgress(r, vh);
      /* Never move further than the scaled image's hidden edge, so no blank gap appears. */
      var cap = Math.min(MAX, (SCALE - 1) / 2 * r.height * 0.9);
      o.img.style.transform = 'translate3d(0,' + (-p * cap).toFixed(1) + 'px,0) scale(' + SCALE + ')';
    }
    /* Campaign text drift (±10px) — a separate, gentler layer. */
    for (i = 0; i < parallaxContentEls.length; i++) {
      r = parallaxContentEls[i].getBoundingClientRect();
      if (r.bottom < -60 || r.top > vh + 60) continue;
      p = parallaxProgress(r, vh);
      parallaxContentEls[i].style.transform = 'translate3d(0,' + (-p * 10).toFixed(1) + 'px,0)';
    }
    /* Campaign overlay opacity shift (~0.20–0.34). */
    for (i = 0; i < parallaxOverlayEls.length; i++) {
      r = parallaxOverlayEls[i].getBoundingClientRect();
      if (r.bottom < -60 || r.top > vh + 60) continue;
      p = parallaxProgress(r, vh);
      parallaxOverlayEls[i].style.opacity = (0.27 + p * 0.07).toFixed(3);
    }
  }

  function onScrollParallax() {
    if (parallaxTicking) return;
    parallaxTicking = true;
    requestAnimationFrame(updateParallax);
  }

  function bindParallax() {
    if (parallaxBound) return;
    parallaxBound = true;
    window.addEventListener('scroll', onScrollParallax, { passive: true });
    window.addEventListener('resize', function () {
      if (parallaxActive()) onScrollParallax();
      else clearParallaxLayers();
    }, { passive: true });
  }

  function clearParallaxLayers() {
    parallaxEls.forEach(function (o) { o.img.style.transform = ''; });
    parallaxContentEls.forEach(function (c) { c.style.transform = ''; });
    parallaxOverlayEls.forEach(function (o) { o.style.opacity = ''; });
  }

  function initParallax() {
    collectParallax();
    if (!parallaxActive()) { clearParallaxLayers(); return; }
    bindParallax();
    updateParallax();
  }

  function initMotion(scope) {
    if (motionOff()) return; /* leave all content in its default visible state */
    setupReveals(scope || document);
    initParallax();
  }

  /* Start the hero zoom only once the hero image is decoded/loaded, so the
     animation is actually seen (and never blocks rendering). */
  function initHeroMedia(scope) {
    var hero = qs('.hero', scope || document);
    if (!hero || hero.__heroMediaBound) return;
    hero.__heroMediaBound = true;
    var ready = function () { hero.classList.add('is-media-ready'); };
    var img = qs('.ph img', hero);
    if (!img) { ready(); return; }
    if (img.complete && img.naturalWidth) { ready(); return; }
    if (typeof img.decode === 'function') {
      img.decode().then(ready).catch(function () {
        if (img.complete) ready(); else img.addEventListener('load', ready, { once: true });
      });
    } else {
      img.addEventListener('load', ready, { once: true });
    }
    setTimeout(ready, 3000); /* safety net; ready() is idempotent */
  }

  /* ---- Phase 1: reactive header (hide on scroll-down, show on scroll-up) ---- */
  var headerMotionBound = false;
  function initHeaderMotion() {
    if (headerMotionBound) return; /* listeners bound once; .nav resolved live for editor reloads */
    headerMotionBound = true;
    var lastY = window.pageYOffset || 0, ticking = false;
    function currentNav() { return qs('.nav'); }
    function update() {
      ticking = false;
      var nav = currentNav();
      if (!nav) return;
      var y = Math.max(0, window.pageYOffset || 0);
      var pinned = overlaysOpen() || nav.contains(document.activeElement) || (window.Shopify && window.Shopify.designMode);
      if (pinned) { nav.classList.remove('nav--hidden'); lastY = y; return; }
      if (y <= 80) { nav.classList.remove('nav--hidden'); nav.classList.remove('nav--scrolled'); lastY = y; return; }
      nav.classList.add('nav--scrolled');
      var delta = y - lastY;
      if (Math.abs(delta) < 8) return; /* ignore jitter; do not update lastY so deltas accumulate */
      if (delta > 0) nav.classList.add('nav--hidden'); else nav.classList.remove('nav--hidden');
      lastY = y;
    }
    function onScroll() { if (ticking) return; ticking = true; requestAnimationFrame(update); }
    window.addEventListener('scroll', onScroll, { passive: true });
    document.addEventListener('focusin', function (e) {
      var nav = currentNav();
      if (nav && nav.contains(e.target)) nav.classList.remove('nav--hidden');
    });
    update();
  }

  /* ---- Phase 2: mobile swipe carousel progress indicator ---- */
  var swipeCarousels = [];
  var swipeResizeBound = false;
  function initSwipeProgress(scope) {
    qsa('[data-swipe-carousel]', scope || document).forEach(function (car) {
      if (car.__swipeProgressBound) return;
      car.__swipeProgressBound = true;
      var wrap = car.parentNode;
      var prog = wrap ? wrap.querySelector('[data-swipe-progress]') : null;
      var fill = prog ? prog.querySelector('.swipe-progress__fill') : null;
      var ticking = false;
      function measure() {
        var scrollable = car.scrollWidth - car.clientWidth;
        if (prog) { if (scrollable > 4) prog.removeAttribute('hidden'); else prog.setAttribute('hidden', ''); }
      }
      function update() {
        ticking = false;
        var scrollable = car.scrollWidth - car.clientWidth;
        if (fill && scrollable > 0) fill.style.width = (Math.max(0, Math.min(1, car.scrollLeft / scrollable)) * 100) + '%';
      }
      function onScroll() { if (ticking) return; ticking = true; requestAnimationFrame(update); }
      car.addEventListener('scroll', onScroll, { passive: true });
      swipeCarousels.push({ el: car, measure: measure, update: update });
      measure(); update();
    });
    ensureSwipeResize();
  }

  /* One shared resize listener recalculates every registered carousel (product + Lookbook). */
  function ensureSwipeResize() {
    if (swipeResizeBound) return;
    swipeResizeBound = true;
    window.addEventListener('resize', function () {
      swipeCarousels.forEach(function (s) { s.measure(); s.update(); });
    }, { passive: true });
  }

  /* ---- Homepage Lookbook full-width swipe carousel ---- */
  /* setActive() is the single source of truth for which video plays. One shared observer
     only tracks the TRACK's vertical visibility — it never starts videos itself. */
  var lookbookTrackObserver = null;
  function getLookbookTrackObserver() {
    if (lookbookTrackObserver) return lookbookTrackObserver;
    lookbookTrackObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        en.target.__lookbookVisible = en.isIntersecting;
        if (typeof en.target.__lookbookSetActive === 'function') en.target.__lookbookSetActive();
      });
    }, { threshold: 0 });
    return lookbookTrackObserver;
  }
  /* Re-evaluate every track (used on reduced-motion change). */
  function refreshLookbookVideos() {
    qsa('[data-lookbook-swipe]').forEach(function (track) {
      if (typeof track.__lookbookSetActive === 'function') track.__lookbookSetActive();
    });
  }

  function initLookbookSwipe(scope) {
    qsa('[data-lookbook-swipe]', scope || document).forEach(function (track) {
      if (track.__lookbookSwipeBound) return;
      track.__lookbookSwipeBound = true;
      var slides = qsa(':scope > [data-lookbook-slide]', track);
      var counter = track.parentNode ? (track.parentNode.parentNode || track.parentNode).querySelector('[data-lookbook-count]') : null;
      var ticking = false;
      track.__lookbookVisible = true;
      track.setAttribute('tabindex', '0'); /* keyboard carousel on desktop + mobile */
      /* Autoplay config — safe defaults; schema-driven via data-attributes (no template change). */
      var autoplayEnabled = track.getAttribute('data-lookbook-autoplay') !== 'false';
      var delayMs = Math.max(3, Math.min(8, parseInt(track.getAttribute('data-lookbook-delay'), 10) || 5)) * 1000;
      var paused = false;     /* hover / focus */
      var lastInteract = 0;   /* manual swipe / scroll-gesture / arrow keys */

      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function activeIndex() { var idx = 0; slides.forEach(function (s, i) { if (s.classList.contains('is-active')) idx = i; }); return idx; }

      function setActive() {
        ticking = false;
        var tr = track.getBoundingClientRect();
        var center = tr.left + tr.width / 2;
        var best = null, bestDist = Infinity, bestIdx = 0;
        slides.forEach(function (s, i) {
          var r = s.getBoundingClientRect();
          var d = Math.abs((r.left + r.width / 2) - center);
          if (d < bestDist) { bestDist = d; best = s; bestIdx = i; }
        });
        var canPlay = track.__lookbookVisible !== false && !reduceMotionMQ.matches;
        slides.forEach(function (s) {
          var active = s === best;
          s.classList.toggle('is-active', active);
          if (active) s.setAttribute('aria-current', 'true'); else s.removeAttribute('aria-current');
          var vid = s.querySelector('[data-lookbook-swipe-video]');
          if (vid) {
            if (active && canPlay) { var p = vid.play(); if (p && typeof p.catch === 'function') p.catch(function () {}); }
            else vid.pause(); /* resume from position; never reset currentTime */
          }
        });
        if (counter) counter.textContent = pad(bestIdx + 1) + ' / ' + pad(slides.length);
      }
      track.__lookbookSetActive = setActive;

      function goToIndex(i) {
        var t = slides[i]; if (!t) return;
        track.scrollTo({ left: t.offsetLeft, behavior: reduceMotionMQ.matches ? 'auto' : 'smooth' });
      }
      function goToNext() { goToIndex((activeIndex() + 1) % slides.length); } /* loop last → first */

      /* ---- Autoplay: advance every delayMs while visible; pause on hover/focus/manual/hidden/reduced ---- */
      function canAdvance() {
        return autoplayEnabled && slides.length > 1 && !reduceMotionMQ.matches
          && track.__lookbookVisible !== false && !document.hidden && !paused
          && (Date.now() - lastInteract) > delayMs;
      }
      function startAutoplay() {
        if (track.__lookbookAutoplayTimer) return;
        if (!autoplayEnabled || slides.length < 2 || reduceMotionMQ.matches) return;
        track.__lookbookAutoplayTimer = setInterval(function () { if (canAdvance()) goToNext(); }, delayMs);
      }
      function stopAutoplay() {
        if (track.__lookbookAutoplayTimer) { clearInterval(track.__lookbookAutoplayTimer); track.__lookbookAutoplayTimer = null; }
      }
      track.__lookbookStartAutoplay = startAutoplay;
      track.__lookbookStopAutoplay = stopAutoplay;

      function onScroll() { if (ticking) return; ticking = true; requestAnimationFrame(setActive); }
      track.addEventListener('scroll', onScroll, { passive: true });
      track.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault(); /* only Left/Right; Up/Down and page scroll untouched */
        lastInteract = Date.now();
        var idx = activeIndex();
        var nextIdx = e.key === 'ArrowRight'
          ? (idx + 1) % slides.length            /* last → first */
          : (idx - 1 + slides.length) % slides.length; /* first → last */
        goToIndex(nextIdx);
      });
      /* Pause on hover/focus; mark real gestures so autoplay waits a cycle (not its own smooth-scroll). */
      track.addEventListener('mouseenter', function () { paused = true; });
      track.addEventListener('mouseleave', function () { paused = false; });
      track.addEventListener('focusin', function () { paused = true; });
      track.addEventListener('focusout', function () { paused = false; });
      ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) {
        track.addEventListener(ev, function () { lastInteract = Date.now(); }, { passive: true });
      });

      /* Desktop prev/next arrows live in the section (outside the scrolling track).
         Reuse goToIndex + lastInteract so a click behaves exactly like a manual
         swipe: it moves one slide and lets autoplay resume after the normal delay. */
      var section = track.closest('.home-lookbook');
      var prevBtn = section ? section.querySelector('[data-lookbook-prev]') : null;
      var nextBtn = section ? section.querySelector('[data-lookbook-next]') : null;
      function goToRelative(step) {
        lastInteract = Date.now();
        var next = (activeIndex() + step + slides.length) % slides.length; /* loops both ends */
        goToIndex(next);
      }
      if (prevBtn) prevBtn.addEventListener('click', function () {
        goToRelative(-1);
        if (prevBtn.__lookbookPointerDown) prevBtn.blur(); /* mouse click: drop focus so autoplay can resume */
      });
      if (nextBtn) nextBtn.addEventListener('click', function () {
        goToRelative(1);
        if (nextBtn.__lookbookPointerDown) nextBtn.blur();
      });
      /* Arrows sit outside the track. Pause autoplay only for *keyboard* focus;
         a mouse click focuses the button too, so we flag pointer interaction and
         skip the pause (and blur after the click) so autoplay resumes normally. */
      [prevBtn, nextBtn].forEach(function (btn) {
        if (!btn) return;
        btn.addEventListener('pointerdown', function () { btn.__lookbookPointerDown = true; });
        btn.addEventListener('focus', function () { if (!btn.__lookbookPointerDown) paused = true; });
        btn.addEventListener('blur', function () { paused = false; btn.__lookbookPointerDown = false; });
      });

      if (supportsIO) getLookbookTrackObserver().observe(track);
      swipeCarousels.push({ el: track, measure: setActive, update: setActive });
      ensureSwipeResize();
      setActive();
      startAutoplay();
    });
  }

  /* ---- Phase 5: exactly one active Fit item (nearest the viewport centre) ---- */
  var fitObserver = null;
  var fitItems = [];
  function updateActiveFit() {
    var mid = window.innerHeight / 2, best = null, bestDist = Infinity, anyVisible = false;
    fitItems.forEach(function (item) {
      var r = item.getBoundingClientRect();
      var visible = r.bottom > 0 && r.top < window.innerHeight;
      if (!visible) return;
      anyVisible = true;
      var d = Math.abs((r.top + r.height / 2) - mid);
      if (d < bestDist) { bestDist = d; best = item; }
    });
    /* Exactly one active while the section is on screen; none when it leaves. */
    fitItems.forEach(function (item) { item.classList.toggle('is-active', anyVisible && item === best); });
  }
  function getFitObserver() {
    if (fitObserver) return fitObserver;
    /* Several thresholds give us re-checks across the scroll without a scroll listener. */
    fitObserver = new IntersectionObserver(function () { updateActiveFit(); },
      { rootMargin: '0px', threshold: [0, 0.25, 0.5, 0.75, 1] });
    return fitObserver;
  }
  function initFitObserver(scope) {
    if (!supportsIO) return;
    qsa('[data-fit-item]', scope || document).forEach(function (item) {
      if (item.__fitObserverBound) return;
      item.__fitObserverBound = true;
      fitItems.push(item);
      getFitObserver().observe(item);
    });
  }

  /* ---- Editorial (silent loop) videos: play only while visible, via one shared observer ---- */
  var editorialVideoObserver = null;
  function getEditorialVideoObserver() {
    if (editorialVideoObserver) return editorialVideoObserver;
    editorialVideoObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;
        if (reduceMotionMQ.matches || !entry.isIntersecting) { video.pause(); return; }
        var p = video.play(); /* do not reset currentTime — resume where it paused */
        if (p && typeof p.catch === 'function') p.catch(function () {}); /* ignore autoplay rejection */
      });
    }, { rootMargin: '15% 0px 15% 0px', threshold: 0.15 });
    return editorialVideoObserver;
  }
  function initEditorialVideos(scope) {
    /* Homepage Lookbook swipe videos are managed by initLookbookSwipe, not this observer. */
    qsa('[data-editorial-video]:not([data-lookbook-swipe-video])', scope || document).forEach(function (video) {
      if (video.__editorialVideoBound) return;
      video.__editorialVideoBound = true;
      getEditorialVideoObserver().observe(video);
    });
  }
  /* Apply current reduced-motion/visibility state immediately (runtime toggles). */
  function refreshEditorialVideos() {
    qsa('[data-editorial-video]:not([data-lookbook-swipe-video])').forEach(function (video) {
      if (reduceMotionMQ.matches) { video.pause(); return; }
      var r = video.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) {
        var p = video.play(); if (p && typeof p.catch === 'function') p.catch(function () {});
      } else { video.pause(); }
    });
  }

  /* React to the user toggling "reduce motion" at runtime (not just on load). */
  function onReduceMotionChange() {
    if (reduceMotionMQ.matches) {
      /* Show everything immediately and stop all movement. */
      qsa('[data-parallax] img').forEach(function (img) { img.style.transform = ''; });
      qsa('.reveal-init').forEach(function (el) { el.classList.remove('reveal-init'); });
      qsa('.reveal-in').forEach(function (el) { el.style.transitionDelay = ''; });
      qsa('[data-parallax-content]').forEach(function (c) { c.style.transform = ''; });
      qsa('[data-parallax-overlay]').forEach(function (o) { o.style.opacity = ''; });
    } else {
      initMotion(document); /* singletons/flags prevent duplicate observers & listeners */
    }
    refreshEditorialVideos(); /* pause when reduced, resume visible ones otherwise */
    refreshLookbookVideos();  /* same for the homepage Lookbook swipe videos */
    /* Stop autoplay outright under reduced motion; resume it when the user turns it off. */
    qsa('[data-lookbook-swipe]').forEach(function (track) {
      if (reduceMotionMQ.matches) {
        if (typeof track.__lookbookStopAutoplay === 'function') track.__lookbookStopAutoplay();
      } else if (typeof track.__lookbookStartAutoplay === 'function') {
        track.__lookbookStartAutoplay();
      }
    });
  }
  if (reduceMotionMQ.addEventListener) reduceMotionMQ.addEventListener('change', onReduceMotionChange);
  else if (reduceMotionMQ.addListener) reduceMotionMQ.addListener(onReduceMotionChange); /* older Safari */

  /* Run each feature in isolation: one failure never blocks the others. */
  function safeInit(name, fn) {
    try { fn(); }
    catch (error) { console.error('[Theme] ' + name + ' failed:', error); }
  }

  document.addEventListener('DOMContentLoaded', function () {
    /* 1) global UI */
    safeInit('overlays', initOverlays);
    safeInit('search', initSearch);
    safeInit('accordions', function () { initAccordions(document); });
    safeInit('cartDrawer', bindCartDrawerEvents);
    safeInit('addToCartForms', initAddToCartForms);
    /* 2) product gallery — must work even if the variant picker fails */
    safeInit('productGallery', initProductGallery);
    /* 3) scroll motion */
    safeInit('motion', function () { initMotion(document); });
    safeInit('heroMedia', function () { initHeroMedia(document); });
    safeInit('editorialVideos', function () { initEditorialVideos(document); });
    safeInit('headerMotion', initHeaderMotion);
    safeInit('swipeProgress', function () { initSwipeProgress(document); });
    safeInit('lookbookSwipe', function () { initLookbookSwipe(document); });
    safeInit('fitObserver', function () { initFitObserver(document); });
    /* 4) product variant picker (most likely to throw on odd product data) */
    safeInit('productPage', initProductPage);
  });

  /* Re-bind a (re)loaded section's controls. Every call is dedup-guarded, so no
     duplicate handlers, no extra global scroll/keydown/scrim/IntersectionObserver. */
  function bindSection(scope) {
    resolveOverlays();
    bindCartDrawerEvents(cart || scope);
    bindOverlayTriggers(scope);
    bindSearchTriggers(scope);
    initAccordions(scope);
    initAddToCartForms(scope);
    initProductGallery(scope);
    initProductPage(scope);
    initMotion(scope);
    initHeroMedia(scope);
    initEditorialVideos(scope);
    initSwipeProgress(scope);
    initLookbookSwipe(scope);
    initFitObserver(scope);
  }

  document.addEventListener('shopify:section:load', function (e) {
    safeInit('section:load', function () { bindSection(e.target); });
  });
  document.addEventListener('shopify:section:reorder', function (e) {
    safeInit('section:reorder', function () { initMotion(e.target); collectParallax(); onScrollParallax(); });
  });
  /* Clean up observers / references for a section removed in Customize (no leaks). */
  document.addEventListener('shopify:section:unload', function (e) {
    if (editorialVideoObserver) {
      qsa('[data-editorial-video]', e.target).forEach(function (video) {
        editorialVideoObserver.unobserve(video);
        video.__editorialVideoBound = false;
      });
    }
    if (fitObserver) {
      qsa('[data-fit-item]', e.target).forEach(function (item) {
        fitObserver.unobserve(item);
        item.__fitObserverBound = false;
      });
      fitItems = fitItems.filter(function (item) { return !e.target.contains(item); });
    }
    qsa('[data-lookbook-swipe]', e.target).forEach(function (t) {
      if (lookbookTrackObserver) lookbookTrackObserver.unobserve(t);
      if (typeof t.__lookbookStopAutoplay === 'function') t.__lookbookStopAutoplay(); /* clear interval, no leaks */
    });
    /* Drop detached carousels so swipeCarousels never holds removed DOM nodes. */
    swipeCarousels = swipeCarousels.filter(function (s) { return !e.target.contains(s.el); });
  });
})();
